// extracted by mini-css-extract-plugin
export default {"subtitle":"eSoR1","noBottomMargin":"uzB-A"};